var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cyber-alarm"},[_c('iframe',{staticClass:"iframe test2",attrs:{"src":_vm.getUrlwithQuery()}})])}
var staticRenderFns = []

export { render, staticRenderFns }